// extracted by mini-css-extract-plugin
module.exports = {"PhotoCropInput":"bfo_a","ReactCrop--disabled":"bfo_b","ReactCrop--circular-crop":"bfo_c"};